import { UserProfession, UserSubProfession } from "../enums/UserProfession";
import { getShouldAllowAdminToPostProcedure, getShouldAllowOfficeToPostProcedureBasedOnProfession } from "../growthbook";
import { MAX_RESTRICTED_POSTING_DAYS_OUT } from "../constants";

export const DefaultGeneralSpecialty = 'specialty_General Dentistry';

/**
 * Returns the max number of days in advance a shift may be posted for the given
 * profession, or null when there is no restriction (DN / Associate Dentist).
 *
 * @param {string} professionCode - dropdown value: 'RDH' | 'DA' | 'FD' | 'DN'.
 *   EFDA selection keeps professionCode === 'DA', so it is covered automatically.
 * @returns {number | null}
 */
export const getMaxPostingDaysOut = (professionCode) =>
  professionCode === UserProfession.DN ? null : MAX_RESTRICTED_POSTING_DAYS_OUT;

export const getIsAllowOfficeToPostProcedure = (professionType, skills) => {
  /** always show procedures when profession is DN */
  const isDNShowProcedures =
    professionType === UserProfession.getName(UserProfession.DN);

  /** show procedures when profession is DA and specialty is non general densistry */
  const isDAShowProcedures =
    (professionType === UserProfession.getName(UserProfession.DA) ||
      professionType === UserSubProfession.getName(UserSubProfession.EFDA)) &&
    skills !== DefaultGeneralSpecialty;

  /**
   * is show procedure based on (`isDNShowProcedures` == TRUE OR `isDAShowProcedures` == TRUE)
   * AND FF `TEMP-11985-should-allow-office-to-post-procedure-based-on-profession` ON
   *  */
  const isShowProceduresBasedOnProfession =
    (isDNShowProcedures || isDAShowProcedures) &&
    getShouldAllowOfficeToPostProcedureBasedOnProfession();

  /**
   * is show procedure if FF `should-allow-office-to-post-procedure` ON
   * OR `isShowProceduresBasedOnProfession` is TRUE
   *  */
  const isShowProceduresLine =
    getShouldAllowAdminToPostProcedure() || isShowProceduresBasedOnProfession;

  return isShowProceduresLine;
};
